// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProductsUI_view__BMwAL {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.ProductsUI_loader__DhQ3q {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
}

.ProductsUI_description__0yqhw {
  width: 200px;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ProductsUI_input__NvOLq {
  background-color: #fbfbfb;
  border-color: #d2d2d2;
  border-radius: 4px;
  width: 300px;
}

.ProductsUI_buttons__cAnsK {
  display: flex;
  justify-content: space-between;
}

.ProductsUI_actions__itAel {
  display: flex;
  justify-content: flex-end;
  gap: 25px;
  align-items: flex-start;
}

.ProductsUI_menu__2fv1A {
  cursor: pointer;
}

.ProductsUI_mainButton__TDgM2 {
  min-width: 200px;
  width: fit-content;
  font-weight: 500;
  &.ProductsUI_syncButton__uycJ5 {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
}

.ProductsUI_header__uRJAI {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}

.ProductsUI_title__UPfpX {
  color: var(--darkGray);
  font-family: BebasNeue;
  font-weight: 700;
  font-size: 20px;
}

.ProductsUI_label__oInvg {
  font-weight: 500;
  color: var(--darkGray);
  font-size: 12px;
}

.ProductsUI_input__NvOLq,
.ProductsUI_input__NvOLq .ant-select-selector {
  background-color: #fbfbfb !important;
  border-color: #d2d2d2 !important;
  border-radius: 4px !important;
}

.ProductsUI_itemColumn__qPGT3 {
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.ProductsUI_itemSubmit__YN62z {
  margin-bottom: 0px;
  text-align: right;
  margin-top: 20px;
}

.ProductsUI_submit__UbSR7 {
  width: 250px;
  font-weight: 700;
  font-size: 13px;
}

.ProductsUI_centerFlexBtn__d-NNS {
  display: flex;
  align-items: center;
  justify-content: center;
}

.ProductsUI_detailsHeader__c6Luh {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  align-items: center;
}

.ProductsUI_detailsImg__rKVBF {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 8px;
}

.ProductsUI_detailsDesc__X1lQ- {
  margin-top: 4px;
  font-style: italic;
  font-size: 13px;
}

.ProductsUI_detailsPrice__rztU- {
  font-size: 15px;
}

.ProductsUI_stepCardTitle__cQlsi {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ProductsUI_stepCardTag__qjKdw {
  padding: 2px 8px;
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  border-radius: 4px;
  color: #1890ff;
  font-size: 12px;
}

.ProductsUI_stepCard__\\+N9N4 {
  border-radius: 8px;
  border: 1px solid #f0f0f0;
}

.ProductsUI_extraListItem__Gm42o {
  margin-bottom: 8px;
}

.ProductsUI_extraCard__4Cgpz {
  border-radius: 6px;
  background-color: #fafafa;
  padding: 4px;
}

.ProductsUI_extraFlexWrapper__Naw5f {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ProductsUI_extraTextWrapper__66hYF {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-width: 0;
}

.ProductsUI_extraTitle__4QUxa {
  font-size: 13px;
  display: block;
}

.ProductsUI_extraSku__SzHGs {
  font-size: 11px;
}

.ProductsUI_extraPrice__GD46a {
  font-size: 12px;
}

.ProductsUI_drawerTabContainer__wXm7b {
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding-top: 10px;
}

.ProductsUI_rowBetweenCenter__F\\+U7U {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ProductsUI_channelSelect__1qvqA {
  width: 180px;
}

.ProductsUI_stepTypeTag__Hu6pr {
  font-size: 11px;
  padding: 2px 6px;
  background: #f5f5f5;
  border-radius: 4px;
  color: #666;
}

.ProductsUI_saveBtnRow__bvmza {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
}

.ProductsUI_placeholderPhoto__ovzib {
  font-size: 18px;
  color: #ccc;
}

.ProductsUI_photoWrapper__6oPUd {
  padding: 4px;
}

.ProductsUI_hoverPhoto__kmsZT {
  max-width: 150px;
  max-height: 150px;
  object-fit: cover;
  border-radius: 4px;
}

.ProductsUI_activePhotoIcon__hdH6G {
  font-size: 18px;
  color: #1890ff;
  cursor: pointer;
}

.ProductsUI_headerIgnoreRuleText__O09hD {
  display: flex;
  align-items: center;
  justify-content: center;
}

.ProductsUI_infoIcon__xVsNb {
  color: #1890ff;
  margin-left: 4px;
  cursor: pointer;
}

.ProductsUI_spacingBottom1em__eT7g0 {
  padding-bottom: 1em;
}

.ProductsUI_syncContainer__79Qqj {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ProductsUI_syncTimeText__SZLDe {
  font-size: 12px;
  margin-top: 4px;
}

.ProductsUI_syncOptionsContainer__KV\\+Up {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.ProductsUI_syncOptionsSpaceBetween__PC8ZM {
  justify-content: space-between;
  width: 100%;
}

.ProductsUI_syncSkuContainer__V7Mt7 {
  margin-top: 10px;
}

.ProductsUI_syncSkuInput__m9GET {
  margin-top: 5px;
}

.ProductsUI_syncSkuHelpText__asNUW {
  font-size: 12px;
}

.ProductsUI_spinCenterContainer__-pTqi {
  text-align: center;
  padding: 30px;
}

.ProductsUI_spinCenterContainerMedium__QsBdd {
  text-align: center;
  padding: 20px;
}

.ProductsUI_titleNoMargin__wrKtu {
  margin: 0 !important;
}

.ProductsUI_dividerMargin15_0__apELf {
  margin: 15px 0 !important;
}

.ProductsUI_dividerMargin10_0__-kO-F {
  margin: 10px 0 !important;
}

.ProductsUI_stepsListContainer__Oqofh {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 15px;
}

.ProductsUI_stepTitleText__JJ41M {
  font-size: 14px;
  font-weight: bold;
}

.ProductsUI_recipeNotFoundContainer__weC2- {
  text-align: center;
  padding: 20px;
}

.ProductsUI_channelAvailabilityRow__5pPSu {
  justify-content: space-between;
  width: 100%;
}

.ProductsUI_stepsSortHelpText__TfBot {
  font-size: 13px;
}

.ProductsUI_stepsEmptyContainer__vzlKv {
  text-align: center;
  padding: 10px;
}

.ProductsUI_syncSection__Xo63K {
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  background-color: #fafafa;
  transition: all 0.3s ease;
}

.ProductsUI_syncSectionActive__UDgWI {
  border-color: #d9d9d9;
  background-color: #ffffff;
}

.ProductsUI_syncSectionDisabled__DrXOc {
  opacity: 0.5;
  pointer-events: none;
  background-color: #f5f5f5;
  border-color: #f0f0f0;
}

.ProductsUI_syncSectionTitle__WDPv0 {
  font-size: 13px;
  font-weight: 600;
  color: #8c8c8c;
  margin-bottom: 12px;
  display: block;
}

.ProductsUI_syncSectionTitleActive__X\\+UDc {
  color: #1890ff;
}

.ProductsUI_syncDividerText__kyGGD {
  color: #bfbfbf;
  font-size: 12px;
  font-weight: 600;
}

.ProductsUI_subProductBtn__1scrZ {
  padding: 0;
  height: auto;
  text-align: left;
  margin-top: 4px;
  font-size: 11px;
}

.ProductsUI_reloadBtn__kvNDk {
  width: 40px;
  min-width: 40px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ProductsUI_rowDragging__-PCce {
  opacity: 0.5;
  background-color: #fafafa;
}

.ProductsUI_rowDragOver__wpE\\+l {
  border-top: 2px solid #1890ff !important;
}

.ProductsUI_dragger__uKG7m {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 8px;
  cursor: grab;
}

/* Premium Channel Availability Card Styles */

.ProductsUI_channelCardList__\\+5cfp {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 10px;
}

.ProductsUI_channelCard__afF3A {
  border-radius: 12px;
  border: 1px solid #f0f0f0;
  padding: 16px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
}

.ProductsUI_channelCard__afF3A:hover {
  border-color: #d9d9d9;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  transform: translateY(-2px);
}

.ProductsUI_channelCardActive__HU39- {
  background: #fafbfc;
  border-color: #e6f7ff;
}

.ProductsUI_channelCardContent__XCpvK {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
}

.ProductsUI_channelHeader__0nEm4 {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1 1;
}

.ProductsUI_channelAvatar__deUhz {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #262626;
  flex-shrink: 0;
}

.ProductsUI_channelInfo__BYkiS {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ProductsUI_channelTitle__BJlvM {
  font-weight: 600;
  font-size: 14px;
  color: #262626;
  margin: 0;
}

.ProductsUI_channelDescription__2M0m3 {
  font-size: 12px;
  color: #8c8c8c;
  line-height: 1.4;
}`, "",{"version":3,"sources":["webpack://./src/pages/products/styles/ProductsUI.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAEhB;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;EAEE,oCAAoC;EACpC,gCAAgC;EAChC,6BAA6B;AAC/B;;AAGA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;;AAEA,6CAA6C;;AAC7C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,iDAAiD;EACjD,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".view {\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.loader {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex: 1;\r\n}\r\n\r\n.description {\r\n  width: 200px;\r\n  display: block;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.input {\r\n  background-color: #fbfbfb;\r\n  border-color: #d2d2d2;\r\n  border-radius: 4px;\r\n  width: 300px;\r\n}\r\n\r\n.buttons {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 25px;\r\n  align-items: flex-start;\r\n}\r\n\r\n.menu {\r\n  cursor: pointer;\r\n}\r\n\r\n.mainButton {\r\n  min-width: 200px;\r\n  width: fit-content;\r\n  font-weight: 500;\r\n\r\n  &.syncButton {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.title {\r\n  color: var(--darkGray);\r\n  font-family: BebasNeue;\r\n  font-weight: 700;\r\n  font-size: 20px;\r\n}\r\n\r\n.label {\r\n  font-weight: 500;\r\n  color: var(--darkGray);\r\n  font-size: 12px;\r\n}\r\n\r\n.input,\r\n.input :global(.ant-select-selector) {\r\n  background-color: #fbfbfb !important;\r\n  border-color: #d2d2d2 !important;\r\n  border-radius: 4px !important;\r\n}\r\n\r\n\r\n.itemColumn {\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  width: 100%;\r\n}\r\n\r\n.itemSubmit {\r\n  margin-bottom: 0px;\r\n  text-align: right;\r\n  margin-top: 20px;\r\n}\r\n\r\n.submit {\r\n  width: 250px;\r\n  font-weight: 700;\r\n  font-size: 13px;\r\n}\r\n\r\n.centerFlexBtn {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.detailsHeader {\r\n  display: flex;\r\n  gap: 20px;\r\n  margin-bottom: 20px;\r\n  align-items: center;\r\n}\r\n\r\n.detailsImg {\r\n  width: 80px;\r\n  height: 80px;\r\n  object-fit: cover;\r\n  border-radius: 8px;\r\n}\r\n\r\n.detailsDesc {\r\n  margin-top: 4px;\r\n  font-style: italic;\r\n  font-size: 13px;\r\n}\r\n\r\n.detailsPrice {\r\n  font-size: 15px;\r\n}\r\n\r\n.stepCardTitle {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.stepCardTag {\r\n  padding: 2px 8px;\r\n  background: #e6f7ff;\r\n  border: 1px solid #91d5ff;\r\n  border-radius: 4px;\r\n  color: #1890ff;\r\n  font-size: 12px;\r\n}\r\n\r\n.stepCard {\r\n  border-radius: 8px;\r\n  border: 1px solid #f0f0f0;\r\n}\r\n\r\n.extraListItem {\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.extraCard {\r\n  border-radius: 6px;\r\n  background-color: #fafafa;\r\n  padding: 4px;\r\n}\r\n\r\n.extraFlexWrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.extraTextWrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.extraTitle {\r\n  font-size: 13px;\r\n  display: block;\r\n}\r\n\r\n.extraSku {\r\n  font-size: 11px;\r\n}\r\n\r\n.extraPrice {\r\n  font-size: 12px;\r\n}\r\n\r\n.drawerTabContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 15px;\r\n  padding-top: 10px;\r\n}\r\n\r\n.rowBetweenCenter {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.channelSelect {\r\n  width: 180px;\r\n}\r\n\r\n.stepTypeTag {\r\n  font-size: 11px;\r\n  padding: 2px 6px;\r\n  background: #f5f5f5;\r\n  border-radius: 4px;\r\n  color: #666;\r\n}\r\n\r\n.saveBtnRow {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  margin-top: 15px;\r\n}\r\n\r\n.placeholderPhoto {\r\n  font-size: 18px;\r\n  color: #ccc;\r\n}\r\n\r\n.photoWrapper {\r\n  padding: 4px;\r\n}\r\n\r\n.hoverPhoto {\r\n  max-width: 150px;\r\n  max-height: 150px;\r\n  object-fit: cover;\r\n  border-radius: 4px;\r\n}\r\n\r\n.activePhotoIcon {\r\n  font-size: 18px;\r\n  color: #1890ff;\r\n  cursor: pointer;\r\n}\r\n\r\n.headerIgnoreRuleText {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.infoIcon {\r\n  color: #1890ff;\r\n  margin-left: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.spacingBottom1em {\r\n  padding-bottom: 1em;\r\n}\r\n\r\n.syncContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.syncTimeText {\r\n  font-size: 12px;\r\n  margin-top: 4px;\r\n}\r\n\r\n.syncOptionsContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 15px;\r\n}\r\n\r\n.syncOptionsSpaceBetween {\r\n  justify-content: space-between;\r\n  width: 100%;\r\n}\r\n\r\n.syncSkuContainer {\r\n  margin-top: 10px;\r\n}\r\n\r\n.syncSkuInput {\r\n  margin-top: 5px;\r\n}\r\n\r\n.syncSkuHelpText {\r\n  font-size: 12px;\r\n}\r\n\r\n.spinCenterContainer {\r\n  text-align: center;\r\n  padding: 30px;\r\n}\r\n\r\n.spinCenterContainerMedium {\r\n  text-align: center;\r\n  padding: 20px;\r\n}\r\n\r\n.titleNoMargin {\r\n  margin: 0 !important;\r\n}\r\n\r\n.dividerMargin15_0 {\r\n  margin: 15px 0 !important;\r\n}\r\n\r\n.dividerMargin10_0 {\r\n  margin: 10px 0 !important;\r\n}\r\n\r\n.stepsListContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 15px;\r\n  margin-top: 15px;\r\n}\r\n\r\n.stepTitleText {\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n}\r\n\r\n.recipeNotFoundContainer {\r\n  text-align: center;\r\n  padding: 20px;\r\n}\r\n\r\n.channelAvailabilityRow {\r\n  justify-content: space-between;\r\n  width: 100%;\r\n}\r\n\r\n.stepsSortHelpText {\r\n  font-size: 13px;\r\n}\r\n\r\n.stepsEmptyContainer {\r\n  text-align: center;\r\n  padding: 10px;\r\n}\r\n\r\n.syncSection {\r\n  padding: 12px;\r\n  border-radius: 8px;\r\n  border: 1px solid #f0f0f0;\r\n  background-color: #fafafa;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.syncSectionActive {\r\n  border-color: #d9d9d9;\r\n  background-color: #ffffff;\r\n}\r\n\r\n.syncSectionDisabled {\r\n  opacity: 0.5;\r\n  pointer-events: none;\r\n  background-color: #f5f5f5;\r\n  border-color: #f0f0f0;\r\n}\r\n\r\n.syncSectionTitle {\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: #8c8c8c;\r\n  margin-bottom: 12px;\r\n  display: block;\r\n}\r\n\r\n.syncSectionTitleActive {\r\n  color: #1890ff;\r\n}\r\n\r\n.syncDividerText {\r\n  color: #bfbfbf;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n}\r\n\r\n.subProductBtn {\r\n  padding: 0;\r\n  height: auto;\r\n  text-align: left;\r\n  margin-top: 4px;\r\n  font-size: 11px;\r\n}\r\n\r\n.reloadBtn {\r\n  width: 40px;\r\n  min-width: 40px;\r\n  padding: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.rowDragging {\r\n  opacity: 0.5;\r\n  background-color: #fafafa;\r\n}\r\n\r\n.rowDragOver {\r\n  border-top: 2px solid #1890ff !important;\r\n}\r\n\r\n.dragger {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding-right: 8px;\r\n  cursor: grab;\r\n}\r\n\r\n/* Premium Channel Availability Card Styles */\r\n.channelCardList {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  margin-top: 10px;\r\n}\r\n\r\n.channelCard {\r\n  border-radius: 12px;\r\n  border: 1px solid #f0f0f0;\r\n  padding: 16px;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  background: #ffffff;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);\r\n}\r\n\r\n.channelCard:hover {\r\n  border-color: #d9d9d9;\r\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.channelCardActive {\r\n  background: #fafbfc;\r\n  border-color: #e6f7ff;\r\n}\r\n\r\n.channelCardContent {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n  gap: 16px;\r\n}\r\n\r\n.channelHeader {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n  flex: 1;\r\n}\r\n\r\n.channelAvatar {\r\n  width: 36px;\r\n  height: 36px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 24px;\r\n  color: #262626;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.channelInfo {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n}\r\n\r\n.channelTitle {\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  color: #262626;\r\n  margin: 0;\r\n}\r\n\r\n.channelDescription {\r\n  font-size: 12px;\r\n  color: #8c8c8c;\r\n  line-height: 1.4;\r\n}\r"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"view": `ProductsUI_view__BMwAL`,
	"loader": `ProductsUI_loader__DhQ3q`,
	"description": `ProductsUI_description__0yqhw`,
	"input": `ProductsUI_input__NvOLq`,
	"buttons": `ProductsUI_buttons__cAnsK`,
	"actions": `ProductsUI_actions__itAel`,
	"menu": `ProductsUI_menu__2fv1A`,
	"mainButton": `ProductsUI_mainButton__TDgM2`,
	"syncButton": `ProductsUI_syncButton__uycJ5`,
	"header": `ProductsUI_header__uRJAI`,
	"title": `ProductsUI_title__UPfpX`,
	"label": `ProductsUI_label__oInvg`,
	"itemColumn": `ProductsUI_itemColumn__qPGT3`,
	"itemSubmit": `ProductsUI_itemSubmit__YN62z`,
	"submit": `ProductsUI_submit__UbSR7`,
	"centerFlexBtn": `ProductsUI_centerFlexBtn__d-NNS`,
	"detailsHeader": `ProductsUI_detailsHeader__c6Luh`,
	"detailsImg": `ProductsUI_detailsImg__rKVBF`,
	"detailsDesc": `ProductsUI_detailsDesc__X1lQ-`,
	"detailsPrice": `ProductsUI_detailsPrice__rztU-`,
	"stepCardTitle": `ProductsUI_stepCardTitle__cQlsi`,
	"stepCardTag": `ProductsUI_stepCardTag__qjKdw`,
	"stepCard": `ProductsUI_stepCard__+N9N4`,
	"extraListItem": `ProductsUI_extraListItem__Gm42o`,
	"extraCard": `ProductsUI_extraCard__4Cgpz`,
	"extraFlexWrapper": `ProductsUI_extraFlexWrapper__Naw5f`,
	"extraTextWrapper": `ProductsUI_extraTextWrapper__66hYF`,
	"extraTitle": `ProductsUI_extraTitle__4QUxa`,
	"extraSku": `ProductsUI_extraSku__SzHGs`,
	"extraPrice": `ProductsUI_extraPrice__GD46a`,
	"drawerTabContainer": `ProductsUI_drawerTabContainer__wXm7b`,
	"rowBetweenCenter": `ProductsUI_rowBetweenCenter__F+U7U`,
	"channelSelect": `ProductsUI_channelSelect__1qvqA`,
	"stepTypeTag": `ProductsUI_stepTypeTag__Hu6pr`,
	"saveBtnRow": `ProductsUI_saveBtnRow__bvmza`,
	"placeholderPhoto": `ProductsUI_placeholderPhoto__ovzib`,
	"photoWrapper": `ProductsUI_photoWrapper__6oPUd`,
	"hoverPhoto": `ProductsUI_hoverPhoto__kmsZT`,
	"activePhotoIcon": `ProductsUI_activePhotoIcon__hdH6G`,
	"headerIgnoreRuleText": `ProductsUI_headerIgnoreRuleText__O09hD`,
	"infoIcon": `ProductsUI_infoIcon__xVsNb`,
	"spacingBottom1em": `ProductsUI_spacingBottom1em__eT7g0`,
	"syncContainer": `ProductsUI_syncContainer__79Qqj`,
	"syncTimeText": `ProductsUI_syncTimeText__SZLDe`,
	"syncOptionsContainer": `ProductsUI_syncOptionsContainer__KV+Up`,
	"syncOptionsSpaceBetween": `ProductsUI_syncOptionsSpaceBetween__PC8ZM`,
	"syncSkuContainer": `ProductsUI_syncSkuContainer__V7Mt7`,
	"syncSkuInput": `ProductsUI_syncSkuInput__m9GET`,
	"syncSkuHelpText": `ProductsUI_syncSkuHelpText__asNUW`,
	"spinCenterContainer": `ProductsUI_spinCenterContainer__-pTqi`,
	"spinCenterContainerMedium": `ProductsUI_spinCenterContainerMedium__QsBdd`,
	"titleNoMargin": `ProductsUI_titleNoMargin__wrKtu`,
	"dividerMargin15_0": `ProductsUI_dividerMargin15_0__apELf`,
	"dividerMargin10_0": `ProductsUI_dividerMargin10_0__-kO-F`,
	"stepsListContainer": `ProductsUI_stepsListContainer__Oqofh`,
	"stepTitleText": `ProductsUI_stepTitleText__JJ41M`,
	"recipeNotFoundContainer": `ProductsUI_recipeNotFoundContainer__weC2-`,
	"channelAvailabilityRow": `ProductsUI_channelAvailabilityRow__5pPSu`,
	"stepsSortHelpText": `ProductsUI_stepsSortHelpText__TfBot`,
	"stepsEmptyContainer": `ProductsUI_stepsEmptyContainer__vzlKv`,
	"syncSection": `ProductsUI_syncSection__Xo63K`,
	"syncSectionActive": `ProductsUI_syncSectionActive__UDgWI`,
	"syncSectionDisabled": `ProductsUI_syncSectionDisabled__DrXOc`,
	"syncSectionTitle": `ProductsUI_syncSectionTitle__WDPv0`,
	"syncSectionTitleActive": `ProductsUI_syncSectionTitleActive__X+UDc`,
	"syncDividerText": `ProductsUI_syncDividerText__kyGGD`,
	"subProductBtn": `ProductsUI_subProductBtn__1scrZ`,
	"reloadBtn": `ProductsUI_reloadBtn__kvNDk`,
	"rowDragging": `ProductsUI_rowDragging__-PCce`,
	"rowDragOver": `ProductsUI_rowDragOver__wpE+l`,
	"dragger": `ProductsUI_dragger__uKG7m`,
	"channelCardList": `ProductsUI_channelCardList__+5cfp`,
	"channelCard": `ProductsUI_channelCard__afF3A`,
	"channelCardActive": `ProductsUI_channelCardActive__HU39-`,
	"channelCardContent": `ProductsUI_channelCardContent__XCpvK`,
	"channelHeader": `ProductsUI_channelHeader__0nEm4`,
	"channelAvatar": `ProductsUI_channelAvatar__deUhz`,
	"channelInfo": `ProductsUI_channelInfo__BYkiS`,
	"channelTitle": `ProductsUI_channelTitle__BJlvM`,
	"channelDescription": `ProductsUI_channelDescription__2M0m3`
};
export default ___CSS_LOADER_EXPORT___;
